import {authRequest, request} from './request';

const uploadBatch = (data: FormData, config: object) => {
    return authRequest({...{
        url: '/batch/check',
        method: 'POST',
        data,
        headers: {'Content-Type': 'multipart/form-data'}
    }, ...config}, 600000);
};

const uploadBatchFinal = (data: FormData) => {
    return authRequest({
        url: '/batch/finalSubmit',
        method: 'POST',
        data,
        headers: {'Content-Type': 'multipart/form-data'}
    }, 600000);
};

const actionCode = () => {
    return authRequest({
        url: '/batch/actionCode',
        method: 'GET'
    });
};

const template = () => {
    return request({
        url: '/public/downloadTemplate',
        method: 'GET'
    });
};

const batchAPI = {uploadBatch, uploadBatchFinal, actionCode, template};

export default batchAPI


// WEBPACK FOOTER //
// ./src/ReduxRequests/APIs/batchAPI.ts